import { render } from "./Daily_Collections_View.vue?vue&type=template&id=7df0cfd3"
import script from "./Daily_Collections_View.vue?vue&type=script&lang=js"
export * from "./Daily_Collections_View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__